import { render, staticRenderFns } from "./FarmCompany.vue?vue&type=template&id=33cd05d4&"
import script from "./FarmCompany.vue?vue&type=script&lang=js&"
export * from "./FarmCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports